import { ReactRouterAppProvider } from "@toolpad/core/react-router";

import { ArgusKeyboardShortcuts } from "./components/argus/argus-keyboard-shortcuts.tsx";
import { ArgusSidebar } from "./components/argus/argus-sidebar.tsx";

import { CommandPalette } from "./components/command-palette.tsx";
import { SupportChat } from "./components/support-chat.tsx";
import { APIKeyProvider } from "./contexts/api-key-context.tsx";
import { SupportChatProvider } from "./contexts/support-chat-context.tsx";
import Layout from "./layouts/dashboard.tsx";
import { ArgusConnectionProvider } from "./providers/argus-connection-provider.tsx";
import { theme } from "./theme/theme.ts";

function App() {
  console.log("Hi there 👋, welcome to Desplega!");

  return (
    <APIKeyProvider loggedIn>
      <SupportChatProvider>
        <ArgusConnectionProvider>
          <ReactRouterAppProvider theme={theme}>
            <Layout />
            <CommandPalette />
            <SupportChat />
            <ArgusSidebar />

            <ArgusKeyboardShortcuts />
          </ReactRouterAppProvider>
        </ArgusConnectionProvider>
      </SupportChatProvider>
    </APIKeyProvider>
  );
}

export default App;
